import { useMutation } from '@tanstack/react-query';
import { submitMailchimpForm } from 'src/interviews/components/EmailTranscript/requests/mailchimp';

const useSubmitForm = (email: string) => {
  const submitForm = (email: string) => submitMailchimpForm(email);
  return useMutation({
    mutationFn: () => submitForm(email),
  });
};

export default useSubmitForm;
